import _extends from 'babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Navbar, Sidebar, AppMain } from './components';
import { mapGetters } from 'vuex';

export default {
  name: 'Layout',
  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain
  },
  computed: _extends({}, mapGetters(['navActiveIndex'])),
  data: function data() {
    return {};
  },

  methods: {
    navClick: function navClick(index) {}
  }
};